// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1Otzj","disabled":"FileBtn_disabled__h8cyl","warn":"FileBtn_warn__3fWME","fade":"FileBtn_fade__3bTU8"};